import React, { Component } from 'react';
import { titleize, unescapeHTML } from 'underscore.string';
import { sluggify } from 'utils/localization/utils';
import { withTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import moment from 'moment';
import TruckIcon from 'components/v2/icons/TruckIcon';
import ClipboardListIcon from 'components/v2/icons/ClipboardListIcon';
import CalendarIcon from 'components/v2/icons/CalendarIcon';
import LocationMarkerIcon from 'components/v2/icons/LocationMarkerIcon';
import IconTextDisplay from 'components/v2/IconTextDisplay';
import { getClassName } from 'utils/ui/classes';
import { getTimeZoneName } from 'utils/Timezones';
import { getLoadQuantity, getLoadDimensions, getLoadWeight, } from '../../../load/Loads';
import { getAbbreviatedTimezone } from '../BookingHelper';
const getActionText = (action) => {
    return action === 'deliver' ? 'delivery' : action;
};
const getTimeText = (start, end, timezone, t) => {
    const dateTimeFormat = 'L LT';
    const timeFormat = 'LT';
    const sameDay = moment(start).isSame(end, 'day');
    const startText = start
        ? moment(start).tz(timezone).format(dateTimeFormat)
        : t('NOT_SET');
    const endText = end
        ? moment(end)
            .tz(timezone)
            .format(sameDay ? timeFormat : dateTimeFormat)
        : t('NOT_SET');
    const tzText = start || end ? `(${getTimeZoneName(timezone)})` : '';
    return `${startText} - ${endText} ${tzText}`;
};
class StopSummaryItem extends Component {
    renderLocation() {
        const { t } = this.props;
        const s = this.props.stop;
        const isFirst = this.props.isFirst;
        const isLast = this.props.isLast;
        const location = s.location[0];
        if (!location.address) {
            return null;
        }
        let color;
        if (isFirst) {
            color = 'green';
        }
        else if (isLast) {
            color = 'red';
        }
        else {
            color = 'gray';
        }
        return (React.createElement(IconTextDisplay, { className: "mb-4", color: color, icon: React.createElement(LocationMarkerIcon, null) },
            React.createElement("div", null,
                React.createElement("div", { className: "text-sm font-bold" }, unescapeHTML(location.name)),
                React.createElement("div", { className: "text-sm form-labael" }, location.address),
                !isEmpty(location.suite_or_apt) && (React.createElement("div", { className: "text-sm" },
                    t('SUITE_APT'),
                    " ",
                    location.suite_or_apt)),
                !isEmpty(location.contact) && (React.createElement("div", { className: "pt-2 text-sm" }, `${location.contact.name} ${location.contact.phone}`)))));
    }
    renderReferenceNumbers() {
        const s = this.props.stop;
        const { t } = this.props;
        if (!s.reference_numbers || s.reference_numbers.length === 0) {
            return null;
        }
        return (React.createElement(IconTextDisplay, { icon: React.createElement(ClipboardListIcon, null) },
            React.createElement("div", { className: "flex flex-wrap -mx-2" }, s.reference_numbers.map((refnum, i) => {
                return (React.createElement("dl", { className: "px-2 mb-2 text-left", key: i },
                    React.createElement("dt", { className: "text-sm text-gray-500 form-medium" }, t(sluggify(refnum === null || refnum === void 0 ? void 0 : refnum.name))),
                    React.createElement("dd", { className: "text-sm text-gray-900 truncate", title: refnum.value }, refnum.value)));
            }))));
    }
    renderLoads() {
        const s = this.props.stop;
        if (!s.loads || s.loads.length === 0) {
            return null;
        }
        const { t } = this.props;
        return (React.createElement(IconTextDisplay, { className: getClassName({ 'items-center': s.loads.length <= 1 }, 'mb-4'), icon: React.createElement(TruckIcon, null) },
            React.createElement("div", { className: "space-y-2" }, s.loads.map((l, i) => (React.createElement("dl", { className: "flex flex-wrap mb-2 -mx-1 text-sm text-left", key: i },
                React.createElement("dd", { className: "px-1" }, getLoadQuantity(l, t)),
                React.createElement("dd", { className: "px-1" }, getLoadDimensions(l)),
                l.stackable && React.createElement("dd", { className: "px-1" }, `${t('STACKABLE')}`),
                React.createElement("dd", { className: "px-1" }, getLoadWeight(l, t))))))));
    }
    render() {
        const { t } = this.props;
        const s = this.props.stop;
        const action = getActionText(s.action);
        const timeSummary = getTimeText(s.window_start, s.window_end, this.props.timezone, t);
        return (React.createElement("div", { key: s.sequence, className: "" },
            React.createElement("hr", null),
            React.createElement("div", { className: "flex justify-between mb-4" },
                React.createElement("h3", { className: "my-0" }, titleize(t(action === null || action === void 0 ? void 0 : action.toUpperCase())))),
            this.renderLocation(),
            !(s === null || s === void 0 ? void 0 : s.appointment_required) && (React.createElement(IconTextDisplay, { className: "items-center mb-4", icon: React.createElement(CalendarIcon, null) },
                React.createElement("div", { className: "text-sm text-gray-900" }, timeSummary))),
            this.renderLoads(),
            this.renderReferenceNumbers()));
    }
}
export default withTranslation()(StopSummaryItem);
